import React from 'react'
import styled from 'styled-components'
import {
  LineItemDTO,
  useBasketLineItem,
  usePrice,
  useGlobalLabels,
  useConfigState,
} from '@sentecacommerce-theme/lib'
import { LazyResponsiveImage, Price, Typography } from '../../../../../Common'

export const ProductPreview = ({ item }: { item: LineItemDTO }) => {
  const {
    images,
    name,
    sku,
    unitDiscountedPrice,
    unitPrice,
    totalPrice: totalPriceRaw,
    quantityInBasket,
    getCustomFieldByKey,
  } = useBasketLineItem({ item })
  const { productNumber } = useGlobalLabels()
  const config = useConfigState()
  const { price, discountPrice } = usePrice({
    price: unitDiscountedPrice || unitPrice,
    discountedPrice: unitDiscountedPrice,
  })

  const hideRegularPrice = getCustomFieldByKey?.(
    config?.customFieldKeys?.hideRegularPrice
  )

  const { price: totalPrice } = usePrice({
    price: totalPriceRaw,
  })

  const withDiscount = Boolean(unitDiscountedPrice)

  return (
    <Item>
      <ImageContainer>
        <LazyResponsiveImage
          breakpointSizes={{}}
          defaultImageWidth="8rem"
          imagesMap={images?.[0]}
          alt={name}
        />
      </ImageContainer>
      <Right>
        <Name>{name}</Name>
        <SKU>{`${productNumber}: ${sku}`}</SKU>
        <Count withDiscount={withDiscount}>
          <Price
            size="xs"
            hideDiscountPercentage
            price={price.value}
            currency={price.currency}
          />
          {' x '} {quantityInBasket}
        </Count>
        <>
          <Price
            size="small"
            hideDiscountPercentage
            price={withDiscount && !!discountPrice ? '' : totalPrice}
            currency={totalPrice?.currency}
            hideRegularPrice={hideRegularPrice}
            discountedPrice={
              withDiscount && !!discountPrice
                ? discountPrice?.value * quantityInBasket
                : undefined
            }
          />
        </>
      </Right>
    </Item>
  )
}

const ImageContainer = styled.div`
  margin-right: 1rem;

  & picture {
    width: 8rem !important;
  }
`

const Item = styled.li.attrs({
  className: 'mb-5',
})`
  display: flex;
  margin-bottom: 1rem;
`

const Right = styled.div``

const SKU = styled.p.attrs({
  className: 'mt-2',
})`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.palette.hint};
`

const Name = styled(Typography).attrs({
  variant: '5',
})``

const Count = styled.div.attrs((props: any) => ({
  className: props.withDiscount ? 'mt-3' : 'mt-3 mb-3',
}))<{ withDiscount?: boolean }>`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.hint};
  display: flex;
  align-items: center;

  & > div > span {
    padding-right: 0.5rem;
  }
`
